module.exports = __webpack_public_path__ + "static/media/like-active.1e5ae575.svg";